import { Component, OnInit, Input } from '@angular/core';
import { Track } from 'src/app/shared/models/track.model';
import { JukeboxService } from 'src/app/shared/services/jukebox.service';

@Component({
  selector: 'app-song-item',
  templateUrl: './song-item.component.html',
  styleUrls: ['./song-item.component.css']
})
export class SongItemComponent implements OnInit {

  @Input() track: Track;

  constructor( public jukeboxService: JukeboxService ) {
  }

  ngOnInit() {
  }

  onTrackSelected() {
    this.jukeboxService.searchOpenSelectedTrack = this.track;
  }
  
}
